import React from 'react';
import Styles from './SeguroAuto25MaoNaRoda.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
function SeguroAuto25MaoNaRoda() {
  return (
    <>
      <section id="seguro-auto-mao-na-roda">
        <ContainerHome24>
          <div className="mao-na-roda-titulos">
            <h2 className="mao-na-roda-titulo">Conheça o Mão na Roda</h2>
            <p className="mao-na-roda-texto">
              O Mão na Roda é um produto de assistências veiculares de reparos abaixo da franquia
              para o uso na sua rotina. Contrate no momento do seu financiamento de veículo e conte
              com os seguintes serviços:
            </p>
          </div>
          <div className="mao-na-roda-servicos">
            <img
              src="assets/seguro-auto-25/mao-na-roda/img-mao-na-roda.svg"
              alt=""
              className="img-mao-na-roda"
            />
            <div className="mao-na-roda-servicos-lista">
              <div className="mao-na-roda-servico">
                <div className="mao-na-roda-servico-ic">
                  <img src="assets/seguro-auto-25/mao-na-roda/ic-pequenos-reparos.svg" alt="" />
                </div>
                <p className="mao-na-roda-servico-texto">Pequenos reparos no seu veículo.</p>
              </div>
              <div className="mao-na-roda-servico">
                <div className="mao-na-roda-servico-ic">
                  <img src="assets/seguro-auto-25/mao-na-roda/ic-troca-pneus.svg" alt="" />
                </div>
                <p className="mao-na-roda-servico-texto">Troca de pneus e rodas.</p>
              </div>
              <div className="mao-na-roda-servico">
                <div className="mao-na-roda-servico-ic">
                  <img src="assets/seguro-auto-25/mao-na-roda/ic-reembolso.svg" alt="" />
                </div>
                <p className="mao-na-roda-servico-texto">
                  Reembolso contra tentativa de roubo e furto.
                </p>
              </div>
              <div className="mao-na-roda-servico">
                <div className="mao-na-roda-servico-ic">
                  <img src="assets/seguro-auto-25/mao-na-roda/ic-mesmo-app.svg" alt="" />
                </div>
                <p className="mao-na-roda-servico-texto">
                  Mesmo app do Portal do Segurado e app Santander Auto.
                </p>
              </div>
            </div>
          </div>
          <div className="mao-na-roda-regulamento">
            <p>
              <a
                href="assets/seguro-auto-25/mao-na-roda/condicoes-contratuais-santander-auto.pdf"
                target="_blank"
              >
                Consulte regulamento
              </a>{' '}
              do Mão na roda
            </p>
          </div>
        </ContainerHome24>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default SeguroAuto25MaoNaRoda;
